import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";

import HeaderHome from "../../components/layout/HeaderHome";
import Breadcrumb from "../../components/seller-store/Breadcrumb";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";

const MembershipAgreement = () => {
    return (
        <>
            {/* ColorInit */}
            <ColorInit color={false} />

            {/* ScrollToTop */}
            <ScrollToTop smooth color="#990A02" />

            {/* Preloader */}
            <Preloader />

            {/* HeaderTwo */}
            {/* <HeaderOne /> */}
            <HeaderHome />

            <div className="container-sm">
               <Typography className="my-30">
                Seller Membership Agreement
               </Typography>
            </div>

            {/* FooterTwo */}
            <FooterOne />

            {/* BottomFooter */}
            <BottomFooter />
        </>
    );
};

export default MembershipAgreement;
